import { FC } from 'react';

import cn from 'classnames';
import DatePicker from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { DateFormates } from 'constants/date.constants';
import { REQUIRED_VALIDATION } from 'constants/validation-rules.constants';
import { ComplaintInput } from 'interfaces/complaints.interfaces';
import { Card } from 'shared-components/Card';
import { ErrorMessage } from 'shared-components/ErrorMessage';
import { FormLabel } from 'shared-components/FormLabel';

interface Props {
  defaultCompletedDate: Date;
  isEditable: boolean;
}

export const ComplaintDatesFields: FC<Props> = ({ defaultCompletedDate, isEditable }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<ComplaintInput>();

  return (
    <Card title='description' wrapperClassName='flex-1' className='flex flex-col gap-4'>
      <div className={cn({ 'flex gap-2 items-center': !isEditable })}>
        <FormLabel
          htmlFor='finishedAt'
          className={cn('mb-2 flex', { 'text-black whitespace-nowrap mb-0': !isEditable })}
        >
          <FormattedMessage id='completed' />
          {isEditable && '*:'}
        </FormLabel>
        <Controller
          control={control}
          name='finishedAt'
          defaultValue={defaultCompletedDate as unknown as string}
          rules={REQUIRED_VALIDATION}
          render={({ field: { value, onChange, ...field } }) => (
            <DatePicker
              {...field}
              showIcon
              disabled={!isEditable}
              minDate={defaultCompletedDate}
              onChange={(date) => {
                date && onChange(date);
              }}
              selected={value ? new Date(value) : defaultCompletedDate}
              dateFormat={DateFormates.defaultDate}
              className='flex-1 h-full disabled:border-0'
              wrapperClassName='w-full'
            />
          )}
        />
        <ErrorMessage>{errors['finishedAt']?.message}</ErrorMessage>
      </div>
    </Card>
  );
};
